module.exports = __webpack_public_path__ + "img/store.c73d240a.svg";